import styled from "@emotion/styled"
import { Container, Typography } from "@mui/material"
import CustomInput from "../../components/custom-input/custom-input.component"
import CustomPhoneInput from "../../components/custom-phone-input/custom-phone-input.component"
import CustomButton from "../../components/custom-button/custom-button.component"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"

export const Section = styled.section`
  background: ${({ theme }) => theme.palette.tertiary.light};
  padding-top: ${({ theme }) => theme.typography.pxToRem("108")};
  padding-bottom: ${({ theme }) => theme.typography.pxToRem("100")};
  margin-top: -3rem;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-top: ${({ theme }) => theme.typography.pxToRem("148")};
    padding-bottom: ${({ theme }) => theme.typography.pxToRem("156")};
  }
`

export const Wrapper = styled(Container)`
  ${({ theme }) => theme.breakpoints.up("sm")} {
    max-width: 718px;
  }
`

export const StepCount = styled(Typography)`
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.75rem;
  letter-spacing: 0.1px;
  margin-bottom: 2.25rem;
  text-align: center;
  opacity: 0.4;
  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem("22")};
    letter-spacing: 0.11px;
    margin-bottom: 2.5rem;
  }
`

export const Title = styled(Typography)`
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 1.5rem;
  line-height: 2.25rem;
  letter-spacing: 0.36px;
  margin-bottom: 1.75rem;
  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: 1.75rem;
    line-height: 2.5rem;
    letter-spacing: 0.42px;
    margin-bottom: 1.5rem;
  }
`

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 20px;
  background: #e6ebfb;
  padding: 2rem 1rem;
  width: 100%;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding: 2rem;
  }
`

export const StyledForm = styled.form`
  .MuiCollapse-wrapperInner {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`

export const StyledInput = styled(CustomInput)`
  .MuiInputLabel-root {
    top: 0 !important;
  }
  .MuiInputLabel-shrink {
    opacity: 1 !important;
    top: 2px !important;
  }
  .MuiOutlinedInput-root {
    height: 52px !important;
    border-radius: 4px !important;
    background-color: ${({ theme }) => theme.palette.text.light} !important;
    border-color: rgba(200, 219, 250, 0.5) !important;
  }
  input {
    padding: 14px !important;
    font-size: ${({ theme }) => theme.typography.pxToRem("15")};
    color: ${({ theme }) => theme.palette.text.primary};
    line-height: normal;
  }
  .MuiInputBase-multiline {
    height: auto !important;
  }
`

export const StyledPhoneInput = styled(CustomPhoneInput)`
  .MuiInput-root {
    border: 1px solid rgba(200, 219, 250, 0.5);
    height: 52px;
    input {
      padding: 13.5px 14px;
    }
  }
`

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: column;
  margin-top: 2.5rem;
  width: 100%;
  ${({ theme }) => theme.breakpoints.up("sm")} {
    flex-direction: row;
    justify-content: center;
    gap: 0.5rem;
    margin-top: ${({ theme }) => theme.typography.pxToRem("60")};
  }
`

export const SubmitBtn = styled(CustomButton)`
  :not(&.job) {
    flex: 1;
  }
  &.job {
    margin: auto;
  }
  ${({ theme }) => theme.breakpoints.up("sm")} {
    width: auto;
    flex: unset;
  }
  > svg {
    margin-right: 10px;
  }
`
export const LastSection = styled(SectionWrapper)`
  background-color: #f7f9ff;
  display: flex;
  padding-top: 0;
  padding-bottom: 10rem;
`
